<template>
  <div class='detail'>
    <back />
    <div class="content">
      <el-descriptions title="基本信息：" :column="4">
        <el-descriptions-item label="用户名">kooriookami</el-descriptions-item>
        <el-descriptions-item label="手机号">18100000000</el-descriptions-item>
        <el-descriptions-item label="居住地">苏州市</el-descriptions-item>
        <el-descriptions-item label="联系地址">江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道 1188 号</el-descriptions-item>
      </el-descriptions>
    </div>
    <el-divider></el-divider>
    <div class="leave_msg">
      <el-descriptions title="留言内容：" :colon="false" :column="1">
        <el-descriptions-item>江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道江苏省苏州市吴中区吴中大道</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  created () {
  },
  methods: {
  },
}
</script>

<style scoped lang='scss'>
.detail {

  .content {
    margin-top: 30px;
  }

  .content,
  .leave_msg {
    ::v-deep .el-descriptions__title {
      color: #1A1A1A;
      font-size: 18px;
    }
  }

  .leave_msg {

    ::v-deep .el-descriptions-item__label {
      margin: 0;
    }
  }

}
</style>
